import * as React from 'react';

import {CloseButton} from 'shells/button/close-button/close-button';
import {LoadingPage} from 'shells/loading-page/loading-page';
import {ModalLightbox} from 'shells/modal/modal-lightbox';
import type {Props as TimelineHeaderProps} from 'shells/timeline/entry/header/timeline-header';
import {TimelineModalHeader} from 'shells/timeline/entry/modals/timeline-modal-header';
import type {TimelineEntryIconVariant} from 'shells/timeline/gutter/types';

import styles from './timeline-modal-wrapper.module.css';

type Props = {
    isLoading?: boolean;
    onClose: () => void;
    iconVariant: TimelineEntryIconVariant;
    children: React.ReactNode;
} & TimelineHeaderProps; // Header props

export function TimelineModalWrapper(props: Props) {
    const {
        isLoading,
        onClose,
        iconVariant,
        timestamp,
        actor,
        actorEmailAddress,
        participants,
        entity,
        entryType,
        changeType,
        numVisits,
        children,
        ...timelineHeaderProps
    } = props;

    return (
        // @ts-expect-error
        <ModalLightbox onClose={onClose} isOpen={true}>
            <div className={styles['timeline-modal']}>
                <CloseButton variant='light' size={16} onClick={onClose} />
                <div className={styles['modal-content-container']}>
                    {isLoading ? (
                        <div className={styles['loading-container']}>
                            <LoadingPage />
                        </div>
                    ) : (
                        <>
                            <TimelineModalHeader
                                iconVariant={iconVariant}
                                timestamp={timestamp}
                                actor={actor}
                                actorEmailAddress={actorEmailAddress}
                                participants={participants}
                                entity={entity}
                                entryType={entryType}
                                changeType={changeType}
                                numVisits={numVisits}
                                {...timelineHeaderProps}
                            />
                            {children}
                        </>
                    )}
                </div>
            </div>
        </ModalLightbox>
    );
}
